import { DateTime, Interval } from 'luxon';

export class PeriodDatetimeBoundaries
{
    public since: DateTime;
    public until: DateTime;
    public nbDays: number;

    constructor (since: DateTime, until: DateTime, untilIncluded: boolean = true)
    {
        this.since = since.startOf('day');
        this.until = until.startOf('day');
        this.nbDays = Interval.fromDateTimes(this.since, this.until.plus({ day: untilIncluded ? 1 : 0 })).length('days');
    }
}
